import React from 'react';
import { useSelector } from 'react-redux';
import { Skeleton } from '@yme/common/components/skeletons';
import { CardHeaderStyled, SubtitleStyled, TitleStyled, } from '@yme/components/Destinations/ExperienceDetailsPage/components/ExperienceDetailsCard/components/CardHeader/styled';
import { getExperienceDetailsPageState } from '@yme/components/Destinations/ExperienceDetailsPage/redux/selectors';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300 } from '@yme/tokens/colors';
export function CardHeader(props) {
    const { isLoaded, isInEditor } = props;
    const { expTitle } = useSelector(getExperienceDetailsPageState);
    const { t } = useTranslation();
    const subtitle = t('destinations_experienceSubtitle_label');
    return (React.createElement(CardHeaderStyled, null,
        React.createElement(SubtitleStyled, { color: colorCoreBlack300 }, subtitle),
        isLoaded || isInEditor ? (React.createElement(TitleStyled, null, expTitle)) : (React.createElement(Skeleton, { skeletonProps: {
                height: 50,
            } }))));
}
